import { images } from '../data';

export default function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="hero-media">
        <img src={images.hero} alt="Balanced stones overlooking a misty landscape" />
        <div className="hero-scrim" aria-hidden="true" />
        <div className="hero-inner container">
          <div className="hero-copy">
            <h1 id="hero-heading">
              Your books. <em>Handled.</em>
            </h1>
            <p className="hero-lede">
              Reliable bookkeeping and payroll for small businesses and independent professionals.
            </p>
            <p className="hero-sub">
              Stay current, know where your business stands, and spend your time running it instead
              of keeping the books.
            </p>
            <div className="hero-actions">
              <a className="btn btn-gold" href="#services">
                View Services
              </a>
            </div>
          </div>

          <div className="hero-seal" role="img" aria-label="30-day 100% satisfaction guarantee">
            <span className="hero-seal-face" aria-hidden="true">
              <span className="hero-seal-star">★</span>
              <strong className="hero-seal-headline">30-Day</strong>
              <span className="hero-seal-rule" />
              <span className="hero-seal-sub">100% Satisfaction</span>
              <span className="hero-seal-sub">Guarantee</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
